import { Filter } from "@bmi-digital/components/filters";

export const xferFilterValue = (
  source: readonly Filter[],
  target: readonly Filter[]
): Filter[] => {
  return target.map((tFilter) => {
    return {
      ...tFilter,
      value:
        source.find((sFilter) => sFilter.filterCode === tFilter.filterCode)
          ?.value || []
    };
  });
};
